import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import SelectDaysForm from './select-days-form';
import TicketBuilderAside from './ticket-builder-aside';
import {
    ROUTE_DAYS,
    ROUTE_TICKETS,
    ROUTE_PARKING,
    ROUTE_PARKING_STANDALONE,
    SCENARIO_HOSPITALITY,
    SCENARIO_PARKING,
    SCENARIO_PARKING_STANDALONE,
    SCENARIO_HOSPITALITY_WITH_EXTRAS
} from './constants';

export default class SelectDaysPage extends React.Component {
    constructor(props) {
        super(props);

        this.onClickContinue = this.onClickContinue.bind(this);
    }

    componentDidMount() {
        if (this.props.hasPreselectedProductGroup && this.isNextStepAvailable()) {
            this.props.history.push(this.getNextRoute());
        }
    }

    onClickContinue(event, onContinue) {
        if (!this.isNextStepAvailable()) {
            event.preventDefault();
        }

        onContinue('Continue', ROUTE_DAYS);
    }

    getNextRoute() {
        let nextRoute = ROUTE_TICKETS;

        if (this.props.currentScenario === SCENARIO_PARKING) {
            nextRoute = ROUTE_PARKING;
        }
        if (this.props.currentScenario === SCENARIO_PARKING_STANDALONE) {
            nextRoute = ROUTE_PARKING_STANDALONE;
        }
        
        return nextRoute;
    }

    generateFormTitle() {
        if (this.props.currentScenario === SCENARIO_HOSPITALITY ||
            this.props.currentScenario === SCENARIO_HOSPITALITY_WITH_EXTRAS
        ) {
            return this.props.categoriesList[0].title;
        }

        return this.props.dictionary.standardTicketsTitle;
    }

    isNextStepAvailable() {
        return this.props.productGroupsList.length > 0;
    }

    render() {
        const isNextStepAvailable = this.isNextStepAvailable();
        const continueBtnDisabledCC = isNextStepAvailable ? '' : 'is-disabled';

        return (
            <React.Fragment>
                <div className="ticket-builder__main">
                    <SelectDaysForm
                        dictionary={this.props.dictionary}
                        basket={this.props.basket}
                        productGroupsList={this.props.productGroupsList}
                        categoriesList={this.props.categoriesList}
                        currentScenario={this.props.currentScenario}
                        formTitle={this.generateFormTitle()}
                        onSelectProductGroup={this.props.onSelectProductGroup}
                    />
                </div>
                <div className="ticket-builder__aside">
                    <TicketBuilderAside productGroupsList={this.props.productGroupsList}
                        basket={this.props.basket}
                        onToggleBasketMobile={this.props.onToggleBasketMobile}
                        basketUrl={this.props.basketUrl}
                        renderControls={(onContinue) => (
                            <div className="ticket-builder__steps-controls">
                                <Link
                                    id='basketContinue'
                                    className={`ticket-builder__button button button--super button--icon ${continueBtnDisabledCC}`}
                                    to={isNextStepAvailable ? this.getNextRoute() : ''}
                                    onClick={(e) => this.onClickContinue(e, onContinue)}>
                                    <span>Continue</span>
                                    <svg className="icon button__arrow-left"
                                        width="14" height="12" focusable="false">
                                        <use xlinkHref="#icon-arrow-right"></use>
                                    </svg>
                                </Link>
                            </div>
                        )}/>
                </div>
            </React.Fragment>
        );
    }
}

SelectDaysPage.propTypes = {
    dictionary: PropTypes.object.isRequired,
    basket: PropTypes.object,
    productGroupsList: PropTypes.array,
    categoriesList: PropTypes.array,
    currentScenario: PropTypes.string.isRequired,
    onSelectProductGroup: PropTypes.func,
    onToggleBasketMobile: PropTypes.func,
    history: PropTypes.object.isRequired,
    hasPreselectedProductGroup: PropTypes.bool.isRequired,
    isParkingStandaloneConfiguration: PropTypes.bool
};
